// Mock data for layout/UI review phase. Replaced with real API once user confirms.

export const IMG = {
  hero: "https://images.unsplash.com/photo-1541475074124-af32f4cb0dbb?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  coffee: "https://images.unsplash.com/photo-1517701986616-711a9d625afe?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  restaurant: "https://images.unsplash.com/photo-1771813156445-1d70dc259856?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  gym: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1200&auto=format&fit=crop",
  run: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?q=80&w=1200&auto=format&fit=crop",
  burger: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?q=80&w=1200&auto=format&fit=crop",
  fish: "https://images.unsplash.com/photo-1542838686-37da4a9fd1b3?q=80&w=1200&auto=format&fit=crop",
  pool: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?q=80&w=1200&auto=format&fit=crop",
  surf: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?q=80&w=1200&auto=format&fit=crop",
  mums: "https://images.unsplash.com/photo-1581952976147-5a2d15560349?q=80&w=1200&auto=format&fit=crop",
  gaming: "https://images.unsplash.com/photo-1542751371-adc38448a05e?q=80&w=1200&auto=format&fit=crop",
  cafe: "https://images.unsplash.com/photo-1518739745383-0ef26e9dd7fd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  restaurantVenue: "https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?q=80&w=1200&auto=format&fit=crop",
  bar: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?q=80&w=1200&auto=format&fit=crop",
  noActivities: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?q=80&w=1200&auto=format&fit=crop",
};

// Communities ("tribes") — flexible groupings so anyone can find their people.
// Not just a meetup app — a friend-connecting app.
export const COMMUNITIES = [
  { id: "active", label: "Active", emoji: "⚡", color: "#FFCC00" },
  { id: "fitness", label: "Fitness", emoji: "💪", color: "#C8E6C9" },
  { id: "mums", label: "Mums & Bubs", emoji: "👶", color: "#FFD8A8" },
  { id: "foodies", label: "Foodies", emoji: "🍴", color: "#FF6A2C" },
  { id: "runners", label: "Runners", emoji: "🏃", color: "#A0CED9" },
  { id: "surfers", label: "Surfers", emoji: "🏄", color: "#7FDBFF" },
  { id: "sports", label: "Sports", emoji: "⚽", color: "#B39DDB" },
  { id: "gamers", label: "Gamers", emoji: "🎮", color: "#FFB3C1" },
  { id: "fishos", label: "Fishos", emoji: "🎣", color: "#9DD9D2" },
  { id: "students", label: "Students", emoji: "📚", color: "#FFFBEB" },
  { id: "newbies", label: "New in town", emoji: "🆕", color: "#FF6F61" },
];

export const getCommunity = (id) => COMMUNITIES.find((c) => c.id === id) || null;

export const AVATARS = [
  // Caucasian / tanned Aussie-style portraits
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  "https://images.unsplash.com/photo-1517841905240-472988babdf9?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
];

export const INTENTS = [
  { id: "meet_new", label: "Meet new people", emoji: "👋" },
  { id: "casual_hang", label: "Casual hang", emoji: "☕" },
  { id: "deep_conv", label: "Deep conversation", emoji: "💭" },
  { id: "networking", label: "Networking", emoji: "🤝" },
  { id: "not_alone", label: "Don't want to go alone", emoji: "🚶" },
];

export const VIBES = [
  { id: "chill", label: "Chill", color: "#C8E6C9" },
  { id: "social", label: "Social", color: "#FFD8A8" },
  { id: "high_energy", label: "High Energy", color: "#FF6A2C" },
  { id: "focused", label: "Focused", color: "#007AFF" },
  { id: "adventurous", label: "Adventurous", color: "#FFCC00" },
  { id: "deep", label: "Deep", color: "#B39DDB" },
  { id: "competitive", label: "Competitive", color: "#FF6F61" },
];

export const ACTIVITY_TYPES = [
  { id: "coffee", label: "Coffee", emoji: "☕" },
  { id: "food", label: "Food", emoji: "🍽️" },
  { id: "gym", label: "Gym", emoji: "💪" },
  { id: "run", label: "Run", emoji: "🏃" },
  { id: "walk", label: "Walk", emoji: "🚶" },
  { id: "surf", label: "Surf", emoji: "🏄" },
  { id: "fish", label: "Fish", emoji: "🎣" },
  { id: "pool", label: "Pool", emoji: "🎱" },
  { id: "sports", label: "Sports", emoji: "⚽" },
  { id: "drinks", label: "Drinks", emoji: "🍸" },
  { id: "study", label: "Study", emoji: "📚" },
  { id: "social", label: "Social", emoji: "🎉" },
  { id: "beach", label: "Beach", emoji: "🏖️" },
  { id: "gaming", label: "Gaming", emoji: "🎮" },
  { id: "kids", label: "Kids", emoji: "👶" },
];

export const CURRENT_USER = {
  id: "u_me",
  name: "Luke",
  email: "luke@grabb.app",
  age: 28,
  avatar: AVATARS[0],
  bio: "Down for a flat white, a surf at Burleigh, a hit of pool or a fish off the rocks.",
  suburb: "Burleigh Heads",
  tokens: 245,
  referral_code: "LUKE8F3A",
  default_intent: ["casual_hang"],
  default_vibe: ["social"],
  interests: ["coffee", "surf", "fish", "pool", "food", "gym"],
  communities: ["surfers", "foodies"],
  // Personalisation: what the app has learned from past behaviour
  history: {
    joined_count: 14,
    top_types: ["coffee", "surf", "fish"],
    top_intents: ["casual_hang", "meet_new"],
    favourite_suburbs: ["Burleigh Heads", "Mermaid Beach", "Currumbin"],
    favourite_venue: "Bumbles Cafe",
  },
};

export const MOCK_USERS = [
  { id: "u1", name: "Mia", age: 26, avatar: AVATARS[1], suburb: "Broadbeach" },
  { id: "u2", name: "Jordan", age: 31, avatar: AVATARS[2], suburb: "Burleigh Heads" },
  { id: "u3", name: "Sam", age: 24, avatar: AVATARS[3], suburb: "Mermaid Beach" },
  { id: "u4", name: "Riley", age: 29, avatar: AVATARS[0], suburb: "Currumbin" },
];

export const MOCK_ACTIVITIES = [
  {
    id: "a1",
    type: "coffee",
    title: "Morning coffee at Bumbles",
    description: "Anyone want to grabb a flat white before work? Outdoor table.",
    host: MOCK_USERS[0],
    time_iso: new Date(Date.now() + 35 * 60 * 1000).toISOString(),
    address: "Budds Beach, Surfers Paradise",
    distance_km: 1.2,
    intent: "casual_hang",
    vibe: "chill",
    spontaneous: true,
    max_participants: 4,
    participants: [MOCK_USERS[0], MOCK_USERS[1]],
    match_score: 0.92,
    match_reasons: ["Both chose casual hang", "1.2 km away", "Matches your usual: coffee"],
    image: IMG.coffee,
    venue: { id: "v2", name: "Bumbles Cafe" },
    deal: null,
    community: "foodies",
  },
  {
    id: "a2",
    type: "run",
    title: "Sunset run along Burleigh boardwalk",
    description: "5k along the headland, easy pace. Looking for someone to chat while we move.",
    host: MOCK_USERS[1],
    time_iso: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    address: "Burleigh Heads Headland",
    distance_km: 3.4,
    intent: "meet_new",
    vibe: "high_energy",
    spontaneous: false,
    max_participants: 6,
    participants: [MOCK_USERS[1], MOCK_USERS[2], MOCK_USERS[3]],
    match_score: 0.78,
    match_reasons: ["3.4 km away", "Type you do often", "Adjacent vibe"],
    image: IMG.run,
    venue: null,
    deal: null,
    community: "runners",
  },
  {
    id: "a3",
    type: "food",
    title: "$15 burgers and chips at Burger Urge",
    description: "Cheap feed on the way home — they're running the $15 burger + chips deal till close.",
    host: MOCK_USERS[2],
    time_iso: new Date(Date.now() + 26 * 60 * 60 * 1000).toISOString(),
    address: "Molendinar",
    distance_km: 5.8,
    intent: "casual_hang",
    vibe: "social",
    spontaneous: false,
    max_participants: 5,
    participants: [MOCK_USERS[2]],
    match_score: 0.81,
    match_reasons: ["Foodies community", "Active deal", "Matches your usual: food"],
    image: IMG.burger,
    venue: { id: "v1", name: "Burger Urge Molendinar" },
    deal: { label: "$15 burgers + chips", color: "#FFCC00" },
    community: "foodies",
  },
  {
    id: "a4",
    type: "gym",
    title: "Push day, anyone?",
    description: "Chest + tris at Goodtimes. Need a spotter.",
    host: MOCK_USERS[3],
    time_iso: new Date(Date.now() + 90 * 60 * 1000).toISOString(),
    address: "James St, Burleigh Heads",
    distance_km: 0.8,
    intent: "not_alone",
    vibe: "focused",
    spontaneous: true,
    max_participants: 2,
    participants: [MOCK_USERS[3]],
    match_score: 0.71,
    match_reasons: ["0.8 km away", "Starts soon", "Matches your usual: gym"],
    image: IMG.gym,
    venue: { id: "v4", name: "Goodtimes Fitness Burleigh" },
    deal: null,
    community: null,
  },
  {
    id: "a5",
    type: "fish",
    title: "Friday arvo fish off The Spit",
    description: "Chasing flatties. BYO rod and a couple of stubbies. Easy hang.",
    host: MOCK_USERS[0],
    time_iso: new Date(Date.now() + 6 * 60 * 60 * 1000).toISOString(),
    address: "The Spit, Main Beach",
    distance_km: 12.4,
    intent: "casual_hang",
    vibe: "chill",
    spontaneous: false,
    max_participants: 6,
    participants: [MOCK_USERS[0], MOCK_USERS[2]],
    match_score: 0.83,
    match_reasons: ["Fishos community", "Matches your usual: fish", "Friday arvo classic"],
    image: IMG.fish,
    venue: null,
    deal: null,
    community: "fishos",
  },
  {
    id: "a6",
    type: "pool",
    title: "Pool & schooners at The Loose Moose",
    description: "Few games of pool, schooner or two. Winner stays on the table.",
    host: MOCK_USERS[1],
    time_iso: new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString(),
    address: "Burleigh Heads",
    distance_km: 0.6,
    intent: "meet_new",
    vibe: "social",
    spontaneous: false,
    max_participants: 6,
    participants: [MOCK_USERS[1]],
    match_score: 0.69,
    match_reasons: ["0.6 km away", "Adjacent vibe: social", "Active happy hour deal"],
    image: IMG.pool,
    venue: { id: "v3", name: "The Loose Moose" },
    deal: { label: "Happy hour 4–6pm", color: "#C8E6C9" },
    community: null,
  },
  {
    id: "a7",
    type: "coffee",
    title: "Mums + bubs coffee at Currumbin",
    description: "Pram-friendly, playground next door. Bring the littlies.",
    host: MOCK_USERS[3],
    time_iso: new Date(Date.now() + 22 * 60 * 60 * 1000).toISOString(),
    address: "Currumbin",
    distance_km: 9.1,
    intent: "casual_hang",
    vibe: "chill",
    spontaneous: false,
    max_participants: 8,
    participants: [MOCK_USERS[3]],
    match_score: 0.42,
    match_reasons: ["Mums & Bubs community", "9.1 km away", "Family friendly"],
    image: IMG.mums,
    venue: null,
    deal: null,
    community: "mums",
  },
  {
    id: "a8",
    type: "gaming",
    title: "Mario Kart night — BYO controller",
    description: "Few of us doing a tournament. Pizza on me if you bring snacks.",
    host: MOCK_USERS[2],
    time_iso: new Date(Date.now() + 30 * 60 * 60 * 1000).toISOString(),
    address: "Mermaid Beach",
    distance_km: 4.3,
    intent: "meet_new",
    vibe: "competitive",
    spontaneous: false,
    max_participants: 6,
    participants: [MOCK_USERS[2], MOCK_USERS[1]],
    match_score: 0.55,
    match_reasons: ["Gamers community", "4.3 km away", "Tomorrow night"],
    image: IMG.gaming,
    venue: null,
    deal: null,
    community: "gamers",
  },
];

export const MOCK_VENUES = [
  { id: "v1", name: "Burger Urge Molendinar", category: "Burgers", image: IMG.burger, distance_km: 5.8, address: "Molendinar, QLD", deal: { label: "$15 burgers + chips", color: "#FFCC00" } },
  { id: "v2", name: "Bumbles Cafe", category: "Cafe", image: IMG.cafe, distance_km: 1.2, address: "Budds Beach, Surfers Paradise", deal: { label: "Buy 2 coffees get 1 free", color: "#C8E6C9" } },
  { id: "v3", name: "The Loose Moose", category: "Bar & Pool", image: IMG.bar, distance_km: 0.6, address: "James St, Burleigh Heads", deal: { label: "Happy hour 4–6pm", color: "#FFCC00" } },
  { id: "v4", name: "Goodtimes Fitness Burleigh", category: "Gym", image: IMG.gym, distance_km: 0.8, address: "James St, Burleigh Heads", deal: { label: "Free guest pass for 2+", color: "#FFFBEB" } },
];

export const MOCK_CREWS = [
  {
    id: "c1",
    name: "Burleigh Coffee Crew",
    members: [MOCK_USERS[0], MOCK_USERS[1], MOCK_USERS[3]],
    compatibility: 0.88,
    last_activity: "Coffee at Bumbles",
    last_active_iso: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    streak: 4, // 4 completed activities together — streak unlocked
    streak_venue: "Bumbles Cafe",
    streak_reward: "Free flat white on the next hang",
  },
  {
    id: "c2",
    name: "Sunset Headland Runners",
    members: [MOCK_USERS[1], MOCK_USERS[2]],
    compatibility: 0.74,
    last_activity: "5k Burleigh Boardwalk",
    last_active_iso: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    streak: 2, // not yet unlocked
    streak_venue: null,
    streak_reward: null,
  },
  {
    id: "c3",
    name: "Friday Arvo Fishos",
    members: [MOCK_USERS[0], MOCK_USERS[2], MOCK_USERS[3]],
    compatibility: 0.81,
    last_activity: "Fish off The Spit",
    last_active_iso: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000).toISOString(),
    streak: 4, // streak active but inactive 13 days → AT RISK
    streak_venue: "The Loose Moose",
    streak_reward: "Free round of pool after the next session",
  },
];

export const MOCK_CHATS = [
  {
    id: "ch1",
    activity_id: "a1",
    title: "Morning coffee at Bumbles",
    last_message: "On my way! 5 min out.",
    last_sender: "Mia",
    last_iso: new Date(Date.now() - 3 * 60 * 1000).toISOString(),
    unread: 2,
    avatars: [AVATARS[1], AVATARS[2]],
  },
  {
    id: "ch2",
    activity_id: "a4",
    title: "Push day, anyone?",
    last_message: "Cool see ya there",
    last_sender: "You",
    last_iso: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
    unread: 0,
    avatars: [AVATARS[0]],
  },
  {
    id: "ch3",
    activity_id: "a3",
    title: "$15 burgers at Burger Urge",
    last_message: "Booked for 4 — confirmed",
    last_sender: "Sam",
    last_iso: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    unread: 0,
    avatars: [AVATARS[3]],
  },
  {
    id: "ch4",
    activity_id: "a5",
    title: "Friday arvo fish off The Spit",
    last_message: "Got bait, see ya at 4",
    last_sender: "Mia",
    last_iso: new Date(Date.now() - 80 * 60 * 1000).toISOString(),
    unread: 1,
    avatars: [AVATARS[1], AVATARS[3]],
  },
];

export const MOCK_MESSAGES = [
  { id: "m1", sender: MOCK_USERS[0], text: "Hey! Stoked you jumped in.", iso: new Date(Date.now() - 30 * 60 * 1000).toISOString(), me: false },
  { id: "m2", sender: CURRENT_USER, text: "Same! What time are you heading down?", iso: new Date(Date.now() - 28 * 60 * 1000).toISOString(), me: true },
  { id: "m3", sender: MOCK_USERS[0], text: "Like 7:45? I'll grabb a table outside.", iso: new Date(Date.now() - 25 * 60 * 1000).toISOString(), me: false },
  { id: "m4", sender: MOCK_USERS[1], text: "I'm in too — running 5 mins late.", iso: new Date(Date.now() - 20 * 60 * 1000).toISOString(), me: false },
  { id: "m5", sender: CURRENT_USER, text: "All good, leaving now.", iso: new Date(Date.now() - 18 * 60 * 1000).toISOString(), me: true },
  { id: "m6", sender: MOCK_USERS[0], text: "On my way! 5 min out.", iso: new Date(Date.now() - 3 * 60 * 1000).toISOString(), me: false },
];

export const MOCK_NOTIFICATIONS = [
  { id: "n1", type: "invite_accepted", title: "Mia jumped into your activity", body: "+3 tokens earned", iso: new Date(Date.now() - 5 * 60 * 1000).toISOString(), unread: true },
  { id: "n2", type: "commit_check", title: "Still coming to coffee?", body: "Starts in 30 min — confirm or cancel.", iso: new Date(Date.now() - 25 * 60 * 1000).toISOString(), unread: true },
  { id: "n3", type: "nearby_invite", title: "New activity nearby", body: "Push day at Goodtimes — 0.8km away", iso: new Date(Date.now() - 60 * 60 * 1000).toISOString(), unread: false },
  { id: "n4", type: "post_activity_checkin", title: "How was the surf?", body: "Rate to earn 10 tokens", iso: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), unread: false },
  { id: "n5", type: "crew_streak", title: "Burleigh Coffee Crew hit a 4-streak!", body: "Free flat white at Bumbles on your next hang.", iso: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString(), unread: true },
];

export const MOCK_TOKEN_TX = [
  { id: "t1", amount: 3, reason: "Mia joined your activity", iso: new Date(Date.now() - 5 * 60 * 1000).toISOString() },
  { id: "t2", amount: 10, reason: "Post-activity check-in", iso: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString() },
  { id: "t3", amount: 25, reason: "Referral verified: SAM2K", iso: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() },
  { id: "t4", amount: -40, reason: "Auto-cancelled (no-show)", iso: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString() },
  { id: "t5", amount: 100, reason: "Welcome bonus", iso: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() },
];

export const MOCK_PULSE = {
  recent_joins_5min: 7,
  new_activities_10min: 3,
  spots_opened: 2,
  active_people: 142,
  nearby_count_10km: 28,
  available_now: 18,
  activities_next_90min: 9,
};

export const MOCK_REFERRALS = [
  { id: "r1", code_used: "LUKE8F3A", referee_name: "Sam", status: "rewarded", iso: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() },
  { id: "r2", code_used: "LUKE8F3A", referee_name: "Alex", status: "signed_up", iso: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString() },
  { id: "r3", code_used: "LUKE8F3A", referee_name: "Casey", status: "clicked", iso: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString() },
];

export const formatTimeFromNow = (iso) => {
  const d = new Date(iso);
  const diffMs = d.getTime() - Date.now();
  const diffMin = Math.round(diffMs / 60000);
  if (Math.abs(diffMin) < 1) return "now";
  if (diffMin > 0) {
    if (diffMin < 60) return `in ${diffMin}m`;
    if (diffMin < 60 * 24) return `in ${Math.round(diffMin / 60)}h`;
    return `in ${Math.round(diffMin / (60 * 24))}d`;
  }
  const abs = Math.abs(diffMin);
  if (abs < 60) return `${abs}m ago`;
  if (abs < 60 * 24) return `${Math.round(abs / 60)}h ago`;
  return `${Math.round(abs / (60 * 24))}d ago`;
};

export const getIntentLabel = (id) => INTENTS.find((i) => i.id === id)?.label || id;
export const getVibeLabel = (id) => VIBES.find((v) => v.id === id)?.label || id;
export const getActivityType = (id) => ACTIVITY_TYPES.find((a) => a.id === id) || { label: id, emoji: "📍" };

// Streak threshold — at 3+ completed activities together, a crew unlocks a venue deal token.
export const CREW_STREAK_THRESHOLD = 3;
export const isCrewStreakUnlocked = (crew) => (crew?.streak || 0) >= CREW_STREAK_THRESHOLD;

// Streak Saver — if the crew has an unlocked streak and hasn't moved in 10+ days,
// auto-suggest a 2-tap re-invite to the host with a small token incentive.
export const STREAK_SAVER_INACTIVE_DAYS = 10;
export const STREAK_SAVER_TOKEN_INCENTIVE = 15;
export const crewDaysInactive = (crew) => {
  if (!crew?.last_active_iso) return 0;
  const diffMs = Date.now() - new Date(crew.last_active_iso).getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
};
export const isStreakAtRisk = (crew) =>
  isCrewStreakUnlocked(crew) && crewDaysInactive(crew) >= STREAK_SAVER_INACTIVE_DAYS;

// Local Legend — earned when user has 5+ verified check-ins at the same venue.
// Free organic ad for the venue, status hook for the user.
export const LOCAL_LEGEND_THRESHOLD = 5;
export const MOCK_LOCAL_LEGENDS = [
  { venue_id: "v2", venue_name: "Bumbles Cafe", checkins: 11, rank: 1, badge_color: "#FFCC00" },
  { venue_id: "v3", venue_name: "The Loose Moose", checkins: 6, rank: 3, badge_color: "#C8E6C9" },
];
